export interface ICountryLabel {
  value: number;
  abbr: string;
  label: string;
}

export const COUNTRY_LABELS: ICountryLabel[] = [
  { abbr: 'AR', label: 'Argentina', value: 107 },
  { abbr: 'AU', label: 'Australia', value: 4 },
  { abbr: 'AT', label: 'Austria', value: 108 },
  { abbr: 'BE', label: 'Belgium', value: 113 },
  { abbr: 'BZ', label: 'Belize', value: 114 },
  { abbr: 'BO', label: 'Bolivia', value: 11 },
  { abbr: 'BR', label: 'Brazil', value: 118 },
  { abbr: 'BG', label: 'Bulgaria', value: 14 },
  { abbr: 'CA', label: 'Canada', value: 3 },
  { abbr: 'KY', label: 'Cayman Islands', value: 243 },
  { abbr: 'CL', label: 'Chile', value: 127 },
  { abbr: 'CN', label: 'China', value: 18 },
  { abbr: 'CO', label: 'Colombia', value: 128 },
  { abbr: 'CR', label: 'Costa Rica', value: 132 },
  { abbr: 'HR', label: 'Croatia', value: 21 },
  { abbr: 'CY', label: 'Cypress', value: 134 },
  { abbr: 'CZ', label: 'Czech Republic', value: 22 },
  { abbr: 'DK', label: 'Denmark', value: 23 },
  { abbr: 'DO', label: 'Dominican Republic', value: 137 },
  { abbr: 'EC', label: 'Ecuador', value: 24 },
  { abbr: 'SV', label: 'El Salvador', value: 138 },
  { abbr: 'EE', label: 'Estonia', value: 26 },
  { abbr: 'FI', label: 'Finland', value: 27 },
  { abbr: 'FR', label: 'France', value: 28 },
  { abbr: 'DE', label: 'Germany', value: 30 },
  { abbr: 'GR', label: 'Greece', value: 32 },
  { abbr: 'GU', label: 'Guam', value: 247 },
  { abbr: 'GT', label: 'Guatemala', value: 34 },
  { abbr: 'HN', label: 'Honduras', value: 149 },
  { abbr: 'HK', label: 'Hong Kong, SAR of China', value: 281 },
  { abbr: 'HU', label: 'Hungary', value: 37 },
  { abbr: 'IS', label: 'Iceland', value: 38 },
  { abbr: 'IN', label: 'India', value: 39 },
  { abbr: 'ID', label: 'Indonesia', value: 40 },
  { abbr: 'IE', label: 'Ireland', value: 42 },
  { abbr: 'IL', label: 'Israel', value: 44 },
  { abbr: 'IT', label: 'Italy', value: 45 },
  { abbr: 'JM', label: 'Jamaica', value: 151 },
  { abbr: 'JP', label: 'Japan', value: 46 },
  { abbr: 'KW', label: 'Kuwait', value: 157 },
  { abbr: 'LV', label: 'Latvia', value: 52 },
  { abbr: 'LI', label: 'Liechtenstein', value: 162 },
  { abbr: 'LT', label: 'Lithuania', value: 55 },
  { abbr: 'LU', label: 'Luxembourg', value: 163 },
  { abbr: 'MO', label: 'Macau, SAR of China', value: 250 },
  { abbr: 'MY', label: 'Malaysia', value: 59 },
  { abbr: 'MT', label: 'Malta', value: 60 },
  { abbr: 'MX', label: 'Mexico', value: 61 },
  { abbr: 'MC', label: 'Monaco', value: 64 },
  { abbr: 'NL', label: 'Netherlands', value: 66 },
  { abbr: 'NZ', label: 'New Zealand', value: 67 },
  { abbr: 'NI', label: 'Nicaragua', value: 178 },
  { abbr: 'NO', label: 'Norway', value: 70 },
  { abbr: 'PA', label: 'Panama', value: 73 },
  { abbr: 'PY', label: 'Paraguay', value: 75 },
  { abbr: 'PE', label: 'Peru', value: 76 },
  { abbr: 'PH', label: 'Philippines', value: 286 },
  { abbr: 'PL', label: 'Poland', value: 78 },
  { abbr: 'PT', label: 'Portugal', value: 79 },
  { abbr: 'PR', label: 'Puerto Rico', value: 249 },
  { abbr: 'QA', label: 'Qatar', value: 184 },
  { abbr: 'KR', label: 'Republic of Korea', value: 49 },
  { abbr: 'RO', label: 'Romania', value: 80 },
  { abbr: 'RU', label: 'Russian Federation', value: 81 },
  { abbr: 'SA', label: 'Saudi Arabia', value: 191 },
  { abbr: 'RS', label: 'Serbia/Montenegro', value: 84 },
  { abbr: 'SG', label: 'Singapore', value: 195 },
  { abbr: 'SK', label: 'Slovakia', value: 86 },
  { abbr: 'SI', label: 'Slovenia', value: 87 },
  { abbr: 'ZA', label: 'South Africa', value: 88 },
  { abbr: 'ES', label: 'Spain', value: 89 },
  { abbr: 'SE', label: 'Sweden', value: 91 },
  { abbr: 'CH', label: 'Switzerland', value: 201 },
  { abbr: 'TW', label: 'Taiwan, China', value: 203 },
  { abbr: 'TH', label: 'Thailand', value: 93 },
  { abbr: 'TT', label: 'Trinidad and Tobago', value: 207 },
  { abbr: 'TR', label: 'Turkey', value: 96 },
  { abbr: 'UA', label: 'Ukraine', value: 97 },
  { abbr: 'AE', label: 'United Arab Emirates', value: 212 },
  { abbr: 'GB', label: 'United Kingdom', value: 2 },
  { abbr: 'US', label: 'United States', value: 1 },
  { abbr: 'UY', label: 'Uruguay', value: 213 },
  { abbr: 'VE', label: 'Venezuela', value: 217 },
  { abbr: 'VN', label: 'Vietnam', value: 99 },
];
